// @flow weak

// Sorted ASC by size. That's important.
export const keys = ['xs', 'sm', 'md', 'lg', 'xl'];

export type IBreakpoints = {
  keys: string[];
  values: number[];
  up: (name: string) => string;
  down: (name: string) => string;
  only: (name: string) => string;
  getWidth: (name: string) => string;
};

export default function createBreakpoints(
  breakpoints = {
    xs: 360,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
  unit = 'px',
  step = 1,
): IBreakpoints {
  const values = keys.map((n) => breakpoints[n]);

  function up(name: string) {
    const value = breakpoints[name] || name;
    return `@media (min-width:${value}${unit})`;
  }

  function down(name: string) {
    const value = breakpoints[name] || name;
    return `@media (max-width:${value}${unit})`;
  }

  function between(start: string, end: string) {
    const startIndex = keys.indexOf(start);
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${values[startIndex]}${unit}) and (max-width:${values[endIndex + 1] - step}${unit})`;
  }

  function only(name: string) {
    const keyIndex = keys.indexOf(name);
    if (keyIndex === keys.length - 1) {
      return up(name);
    }
    return between(name, name);
  }

  function getWidth(name: string) {
    return breakpoints[name];
  }

  return { keys, values, up, down, only, getWidth };
}
